import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
const AmwayInsider = (props) => {
  const { scriptSrc, argument } = props;
  const cookie = new Cookies();
  const ada = cookie.get("ada");
  const role = cookie.get("role");
  const user = {
    uuid: ada ?? "",
    custom: {
      distributortype: role ?? "",
    }
  }
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window !== undefined) {
      window.insider_object = {
        ...argument,
      };
      let scriptDom = document.createElement("script");
      scriptDom.async = "async";
      scriptDom.type = "text/javascript";
      scriptDom.src = scriptSrc;
      scriptDom.integrity = "sha384-spWt6pTIxi7BvA6uO48RW1QpN1s0Un2l9nYP2prE48g8sJ2HVDF2Tcid9xsMEt67";
      scriptDom.crossorigin = "anonymous";
      scriptDom.id = "INSIDER";
      if (document.getElementById("root")) {
        document.getElementById("root").appendChild(scriptDom);
      }
      else {
        document.getElementById("__next").appendChild(scriptDom);
      }
    }
  }, []);

  //  獲取 INSIDER  上報詳情信息
  useEffect(() => {
    if (ada && ada !== "" && role && role !== "") {
      const insider_object = window?.insider_object || {}
      window.insider_object = {
        user: {
          "gdpr_optin": true,
          ...user,
        },
        ...insider_object
      };
    }
  }, [ada, role]);
  return <></>;
}
AmwayInsider.defaultProps = {
  argument: {},
  scriptSrc: "https://amwaytw.api.useinsider.com/ins.js?id=10005234",
};
AmwayInsider.propTypes = {
  argument: PropTypes.string | PropTypes.object,
  scriptSrc: PropTypes.string,
};
export default AmwayInsider 